export default "__VITE_ASSET__CZQgQT6U__";